import { authRoles } from 'app/auth/authRoles'
import { adminRoutesPrefix } from 'config'
import React from 'react'

const pagesRoutes = [
  {
    exact: true,
    path: `${adminRoutesPrefix}`,
    component: React.lazy(() => import('./AdminHomePage')),
    auth: authRoles.admin
  },
  {
    exact: true,
    path: `${adminRoutesPrefix}/users`,
    component: React.lazy(() => import('./users/UserListPage')),
    auth: authRoles.admin
  },
  {
    exact: true,
    path: `${adminRoutesPrefix}/users/:id`,
    component: React.lazy(() => import('./users/UserViewPage')),
    auth: authRoles.admin
  },
  {
    path: `${adminRoutesPrefix}/users/:id/edit`,
    component: React.lazy(() => import('./users/UserFormPage')),
    auth: authRoles.admin
  },
  {
    path: `${adminRoutesPrefix}/new-user`,
    component: React.lazy(() => import('./users/UserFormPage')),
    auth: authRoles.admin
  },
  {
    exact: true,
    path: `${adminRoutesPrefix}/roles`,
    component: React.lazy(() => import('./roles/RoleListPage')),
    auth: authRoles.admin
  },
  {
    path: `${adminRoutesPrefix}/roles/:id/edit`,
    component: React.lazy(() => import('./roles/RoleFormPage')),
    auth: authRoles.admin
  },
  {
    exact: true,
    path: `${adminRoutesPrefix}/new-role`,
    component: React.lazy(() => import('./roles/RoleFormPage')),
    auth: authRoles.admin
  },
  {
    exact: true,
    path: `${adminRoutesPrefix}/groups`,
    component: React.lazy(() => import('./groups/GroupListPage')),
    auth: authRoles.admin
  },
  {
    path: `${adminRoutesPrefix}/groups/:id/edit`,
    component: React.lazy(() => import('./groups/GroupFormPage')),
    auth: authRoles.admin
  },
  {
    exact: true,
    path: `${adminRoutesPrefix}/new-group`,
    component: React.lazy(() => import('./groups/GroupFormPage')),
    auth: authRoles.admin
  },
    {
    exact: true,
    path: `${adminRoutesPrefix}/enterprises`,
    component: React.lazy(() => import('./enterprises/EnterpriseListPage')),
    auth: authRoles.admin
  },
  {
    exact: true,
    path: `${adminRoutesPrefix}/enterprises/:id`,
    component: React.lazy(() => import('./enterprises/EnterpriseViewPage')),
    auth: authRoles.admin
  },  
  {
    exact: true,
    path: `${adminRoutesPrefix}/enterprise/usage`,
    component: React.lazy(() => import('./enterprises/UsageListPage')),
    auth: authRoles.admin
  }, 
  {
    exact: true,
    path: `${adminRoutesPrefix}/billing/configuration`,
    component: React.lazy(() => import('./billing/CustomBillingConfigPage')),
    auth: authRoles.admin
  },
  {
    exact: true,
    path: `${adminRoutesPrefix}/signup`,
    component: React.lazy(() => import('./signup/SignupListPage')),
    auth: authRoles.admin
  },
  {
    exact: true,
    path: `${adminRoutesPrefix}/signup/new`,
    component: React.lazy(() => import('./signup/SignupFormPage')),
    auth: authRoles.admin
  }
]

export default pagesRoutes
